import { KEY_PRICE } from '@scandipwa/scandipwa/src/component/CategoryFilterOverlay/CategoryFilterOverlay.config';
import { setQueryParams } from '@scandipwa/scandipwa/src/util/Url';
import { connect } from 'react-redux';

import {
    CategoryFilterOverlayContainer as SourceCategoryFilterOverlayContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.container';
import history from 'Util/History';

export {
    mapStateToProps,
    mapDispatchToProps,
};

export class CategoryFilterOverlayContainer extends SourceCategoryFilterOverlayContainer {
    updateFilter(filterName, filterArray) {
        const { location } = history;

        setQueryParams({
            customFilters: this.getFilterUrl(filterName, filterArray, false),
            page: '',
        }, location, history);
    }

    toggleCustomFilter(requestVar, value) {
        this.updateFilter(requestVar, this._getNewFilterArray(requestVar, String(value)));
    }

    /**
    * Returns filter array with new parameters
    *
    * @param {String} filterKey key of option
    * @param {String} value
    * @returns {Object[]}
    * @memberof CategoryShoppingOptions
    */
    _getNewFilterArray(filterKey, value) {
        const { customFiltersValues, customFiltersValues: { price, total_carat_weight } } = this.props;
        const newFilterArray = customFiltersValues[
            filterKey
        ] !== undefined
            ? Array.from(customFiltersValues[filterKey])
            : [];

        const filterValueIndex = newFilterArray.indexOf(value);

        if (filterKey === KEY_PRICE) {
            return price && price.includes(value)
                ? []
                : [value];
        }

        if (filterKey === "total_carat_weight") {
            return [total_carat_weight.join(",")] && [total_carat_weight.join(",")].includes(value)
                ? []
                : [value];
        }

        if (filterValueIndex === -1) {
            newFilterArray.push(value);
        } else {
            newFilterArray.splice(filterValueIndex, 1);
        }

        return newFilterArray;
    }

    getFilterUrl(filterName, filterArray, isFull = true) {
        const { location: { pathname } } = history;
        const selectedFilters = this._getNewSelectedFiltersString(filterName, filterArray);
        const customFilters = isFull ? `${pathname}?customFilters=` : '';
        const formattedFilters = this._formatSelectedFiltersString(selectedFilters);

        return `${customFilters}${formattedFilters}`;
    }

    _getNewSelectedFiltersString(filterName, filterArray) {
        const prevCustomFilters = this._getSelectedFiltersFromUrl();
        const customFilers = {
            ...prevCustomFilters,
            [filterName]: filterArray.length > 1 ? filterArray.slice(1) : filterArray,
        };

        return Object.entries(customFilers)
            .reduce((accumulator, [filterKey, filterValue]) => {
                if (filterValue.length) {
                    const filterValues = filterValue.sort().join(',');

                    accumulator.push(`${filterKey}:${filterValues}`);
                }

                return accumulator;
            }, [])
            .sort()
            .join(';');
    }

    onSeeResultsClick() {
        const {
            hideActiveOverlay,
            goToPreviousHeaderState,
            goToPreviousNavigationState,
        } = this.props;

        hideActiveOverlay();
        goToPreviousHeaderState();
        goToPreviousNavigationState();
    }

    containerProps() {
        const {
            availableFilters,
            customFiltersValues,
            isCategoryAnchor,
            isInfoLoading,
            isMatchingInfoFilter,
            isProductsLoading,
            isSearchPage,
            totalPages,
            onFilterButtonClick,
            onFilterClose
        } = this.props;

        return {
            availableFilters,
            isCategoryAnchor,
            isInfoLoading,
            isProductsLoading,
            isMatchingInfoFilter,
            isSearchPage,
            totalPages,
            customFiltersValues,
            areFiltersEmpty: this.getAreFiltersEmpty(),
            isContentFiltered: this.isContentFiltered(),
            onFilterButtonClick,
            onFilterClose
        };
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFilterOverlayContainer);
